var stickyBar__variant = document.querySelectorAll(".stickyBar__variant");

stickyBar__variant.forEach((variant) => {
    variant.addEventListener("click", function () {
        var variantValueInput = document.getElementById("stickyVariantID");
        var variantDefaultTitle = document.querySelector(".default-title");
        var varianButtonTitle = document.querySelector(".product-buy-buttons--cta.product-buy-buttons--routine.product-add-to-cart-button");
        var varianStickyVariant = document.querySelector(".sticky-variants-dropdown");
        var varianStickyVariantID = document.querySelector("#stickyBar-variant-dropdown-btn");
        stickyBar__variant.forEach((otherVariant) => {
            if (variantDefaultTitle) {
                variantDefaultTitle.classList.remove("active__variant-title");
            }
            if (varianButtonTitle) {
                varianButtonTitle.classList.remove("active__variant-button");
            }
            varianButtonTitle.closest('.stickyBar__grid').classList.remove("active__variant-button");
            if (varianStickyVariant) {
                varianStickyVariant.classList.remove("active__variant-sticky");
            }
            if (varianStickyVariantID) {
                varianStickyVariantID.classList.remove("active__variant-sticky");
            }
            otherVariant.classList.remove("active__variant");
        });
        variant.classList.add("active__variant");
        if (variantDefaultTitle) {
            variantDefaultTitle.classList.add("active__variant-title");
        }
        if (varianButtonTitle) {
            varianButtonTitle.classList.add("active__variant-button");
        }
        varianButtonTitle.closest('.stickyBar__grid').classList.add("active__variant-button");
        if (varianStickyVariant) {
            varianStickyVariant.classList.add("active__variant-sticky");
        }
        if (varianStickyVariantID) {
            varianStickyVariantID.classList.add("active__variant-sticky");
        }
        var selectedVariant = variant.querySelector("label").getAttribute("data-variant-id");

        var variant_regular_price = document.querySelector(".routine-price .regular-price");
        var variant_compare_price = document.querySelector(".routine-price .compare-price");
        var selected_regular_price = variant.querySelector("label").getAttribute("data-regular-price");
        var selected_compare_price = variant.querySelector("label").getAttribute("data-compare-price");
        var selected_title = variant.querySelector(".stickyBar__variant-title").innerHTML;
        var selected_variant_id = variant.querySelector("label").getAttribute("data-variant-id");

        variantValueInput.value = selectedVariant;

        variant_regular_price.textContent = selected_regular_price;
        variant_compare_price.textContent = selected_compare_price;
        if(document.querySelector("#stickyBar-selected-option") != null){
            document.querySelector("#stickyBar-selected-option").innerHTML = selected_title;
        }
        if(document.querySelector("#stickyBar-selected-variant") != null){
            document.querySelector("#stickyBar-selected-variant").innerHTML = selected_title;
        }
        document.querySelector("#stickyBar-mobile-cta .routine-price .regular-price").textContent = selected_regular_price;
        document.querySelector("#stickyBar-mobile-cta .routine-price .compare-price").textContent = selected_compare_price;

        var variant_id_selector = 'label[data-variant-id="' + selected_variant_id + '"]';
        document.querySelectorAll(variant_id_selector).forEach((selector) => {
            if (variant.querySelector("label") != selector) selector.click();
        });

        // Subscription Layout sticky Popup
        var check_sticky_popup = document.querySelector(".has-sticky-subscription-loop .stickyBar__variants");
        if(check_sticky_popup != null && check_sticky_popup.classList.contains('open')){
            // document.querySelector(".stickyBar-inner-wrapper .sticky-variants-dropdown").classList.add('variant-selected');
            var sticky_variant_title = this.querySelector('.stickyBar__variant-title').innerHTML;
            document.querySelector(".stickyBar-inner-wrapper .selected-variant").innerHTML = sticky_variant_title;
            document.querySelector(".stickyBar-inner-wrapper .sticky-variants-dropdown").classList.remove('active');
            document.querySelector(".stickyBar-inner-wrapper .stickyBar__variants").classList.remove('open');
        }
    });
});

// Function to toggle active class on .stickyBar__variants-wrapper and .stickyBar-variant-dropdown
function toggleActiveClass(event) {
    if(event.target.closest(".loop-subscription-container")) return;
    document.querySelector("body").classList.toggle("sticky-open");
    document.querySelector(".stickyBar__variants-wrapper").classList.toggle("active");
    document.querySelector(".stickyBar-variant-dropdown").classList.toggle("active");
}

// Add event listener to each .stickyBar__variant element
document.querySelectorAll(".stickyBar__variant").forEach(function (element) {
    element.addEventListener("click", function (event) {
        toggleActiveClass(event);
    });
});

// Function to handle click events on the body
function bodyClickHandler(event) {
    // Check if the clicked element is not #stickyBar-variant-dropdown-btn and not inside .stickyBar__variants-wrapper
    if (!event.target.closest("#stickyBar-variant-dropdown-btn") && !event.target.closest(".stickyBar__variants-wrapper")) {
        // Remove the 'active' class from the appropriate elements
        if(event.target.closest(".loop-subscription-container")) return;
        document.querySelector(".stickyBar__variants-wrapper").classList.remove("active");
        document.querySelector(".stickyBar-variant-dropdown").classList.remove("active");
    } else {
        console.log("Clicked inside, not removing active class...");
    }
}

function bodyClickHandlerMobile(event) {
    // Check if the clicked element is not #stickyBar-variant-dropdown-btn and not inside .stickyBar__variants-wrapper
    if (!event.target.closest("#stickyBar-mobile-cta") && !event.target.closest(".stickyBar__grid ")) {
        // Remove the 'active' class from the appropriate elements
        if(event.target.closest(".loop-subscription-container")) return;
        document.querySelector(".stickyBar__grid").classList.remove("active");
        document.querySelector("body").classList.remove("mobile-sticky-open");
        document.querySelector("#stickyBar-mobile-cta").classList.add("active");
        document.querySelector("body").classList.remove("overflow-hidden");

    } else {
        console.log("Clicked inside, not removing active class...");
    }
}

if (document.querySelector(".stickyBar__variants-wrapper")) {
    document.body.addEventListener("click", bodyClickHandler);
}

if (document.querySelector(".stickyBar__grid")) {
    document.body.addEventListener("click", bodyClickHandlerMobile);
}

var button = document.querySelector('.product-buy-buttons--cta.product-buy-buttons--routine.product-add-to-cart-button');
if (button) {
    button.addEventListener('click', function() {
        document.body.classList.remove('mobile-sticky-open');
    });
}

// Get all elements with the class 'stickyBar__variant'
var variantsData = document.querySelectorAll('.stickyBar__variant');

// Get the target element
var targetVariant = document.querySelector('.stickyBar__grid');

// Loop through each element with the class 'stickyBar__variant'
variantsData.forEach(function(variant) {
    // Add click event listener to each element
    variant.addEventListener('click', function() {
        // Add 'highlight' class to the target element
        targetVariant.classList.add('active');
        document.querySelector("#stickyBar-mobile-cta").classList.remove('active');
        document.querySelector("body").classList.add("mobile-sticky-open");
        document.querySelector("body").classList.add("overflow-hidden");
    });
});


// Event listener for toggling the active class
if (document.querySelector("#stickyBar-variant-dropdown-btn")) {
    document.querySelector("#stickyBar-variant-dropdown-btn").addEventListener("click", (event) => {
        toggleActiveClass(event);
    });
}

// Prevent click events inside .stickyBar__variants-wrapper from bubbling up to the body
if (document.querySelector(".stickyBar__variants-wrapper")) {
    document.querySelector(".stickyBar__variants-wrapper").addEventListener("click", (event) => {
        event.stopPropagation();
    });
}
document.querySelector("#stickyBar-productForm").addEventListener("submit", async (e) => {
    e.preventDefault();
    const variant_id = e.target.querySelector('input[name="id"]').value;
    const quantity = e.target.querySelector('input[name="quantity"]').value;

    let item = {};
    item.id = variant_id;
    item.quantity = quantity;
    if(document.querySelector('.stickyBar__container .loop-subscription-container')){
      item.loop_purchase_option = 'on';
      item.loop_variant_id = variant_id;
      item.selling_plan = document.querySelector('input[name="selling_plan"]').value;
    }

    const formData = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            items: [
                item,
            ],
        }),
    };
    await theme.cart.addItem(formData, variant_id), theme.drawer.open("right", "cart-drawer");
    if (document.querySelector(".stickyBar__variants-wrapper").classList.contains("active")) {
        document.querySelector(".stickyBar__variants-wrapper").classList.toggle("active");
        document.querySelector(".stickyBar-variant-dropdown").classList.toggle("active");
    }
    if (document.querySelector("#stickyBar .stickyBar__grid").classList.contains("active")) {
        document.querySelector("#stickyBar-mobile-cta").classList.toggle("active");
        document.querySelector("#stickyBar .stickyBar__grid").classList.toggle("active");
    }
});

document.querySelector("#stickyBar-mobile-cta").addEventListener("click", (e) => {
    document.querySelector("#stickyBar-mobile-cta").classList.toggle("active");
    document.querySelector("#stickyBar .stickyBar__grid").classList.toggle("active");
    document.querySelector("body").classList.toggle("mobile-sticky-open");
    document.querySelector("body").classList.toggle("overflow-hidden");
});
document.querySelector("#stickyBar-close-popup").addEventListener("click", (e) => {
    document.querySelector("#stickyBar-mobile-cta").classList.toggle("active");
    document.querySelector("#stickyBar .stickyBar__grid").classList.toggle("active");
    document.querySelector("body").classList.toggle("mobile-sticky-open");
    document.querySelector("body").classList.toggle("overflow-hidden");

});

function stickyBarLoad(){
    if (document.querySelector(".skinRoutine .product-buy-buttons--cta")) {
        if (document.querySelector(".stickyBar__variants-wrapper") != null) {
           if(document.querySelector(".loop-subscription-container") == null){
            if (document.querySelector(".stickyBar__variants-wrapper").classList.contains("active")) {
                document.querySelector(".stickyBar__variants-wrapper").classList.toggle("active");
                document.querySelector(".stickyBar-variant-dropdown").classList.toggle("active");
            }
            if (document.querySelector("#stickyBar .stickyBar__grid").classList.contains("active")) {
                document.querySelector("#stickyBar-mobile-cta").classList.toggle("active");
                document.querySelector("#stickyBar .stickyBar__grid").classList.toggle("active");
            }
        }
        }
    }

    // Get the element to check if it's in the viewport
    var el = document.querySelector(".clearRoutine__container .product-buy-buttons--cta");

    // Get its dimensions and position
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    // Adjust position considering all offsetParents
    while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    // Get the element to check if it's in the viewport
    if (document.querySelector(".skinRoutine .product-buy-buttons--cta")) {
        var el2 = document.querySelector(".skinRoutine .product-buy-buttons--cta");
    }

    // Get its dimensions and position
    var top2 = el2.offsetTop;
    var left2 = el2.offsetLeft;
    var width2 = el2.offsetWidth;
    var height2 = el2.offsetHeight;

    // Adjust position considering all offsetParents
    while (el2.offsetParent) {
        el2 = el2.offsetParent;
        top2 += el2.offsetTop;
        left2 += el2.offsetLeft;
    }

    // Check if the element is in the viewport
    if (top2 < window.pageYOffset + window.innerHeight && left2 < window.pageXOffset + window.innerWidth && top2 + height2 > window.pageYOffset && left2 + width2 > window.pageXOffset) {
        // Hide the sticky bar if the element is in the viewport
        document.querySelector("#stickyBar").style.display = "none";
    } else if (top < window.pageYOffset + window.innerHeight && left < window.pageXOffset + window.innerWidth && top + height > window.pageYOffset && left + width > window.pageXOffset) {
        // Hide the sticky bar if the element is in the viewport
        document.querySelector("#stickyBar").style.display = "none";
    } else {
        // Show the sticky bar if the element is not in the viewport
        document.querySelector("#stickyBar").style.display = "block";
    }

    function getOffsetTop(element) {
        var offsetTop = 0;
        while (element) {
            offsetTop += element.offsetTop;
            element = element.offsetParent;
        }
        return offsetTop;
    }

    // Hide Sticky ATC bar when footer s in viewport
    if ($(".bundle-lp-footer").length > 0) {
      var top_of_element = $(".bundle-lp-footer").offset().top;
      var bottom_of_element = $(".bundle-lp-footer").offset().top + $(".bundle-lp-footer").outerHeight();
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      var top_of_screen = $(window).scrollTop();

      if (bottom_of_screen > top_of_element && top_of_screen < bottom_of_element) {
          $("#stickyBar").addClass("hiddenBar");
      } else {
          $("#stickyBar").removeClass("hiddenBar");
      }
    }

    // Hide CTA when single bundle CTA in viewport
    if ($("#sb-bundle-btn").length > 0) {
        var top_of_element = $("#sb-bundle-btn").offset().top;
        var bottom_of_element = $("#sb-bundle-btn").offset().top + $("#sb-bundle-btn").outerHeight();
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();

        if (bottom_of_screen > top_of_element && top_of_screen < bottom_of_element) {
            $("#stickyBar").addClass("has-bundle-cta");
        } else {
            $("#stickyBar").removeClass("has-bundle-cta");
        }
    }
  }

stickyBarLoad();
document.addEventListener("scroll", (e) => {
  stickyBarLoad();
});

// Subscription Dropdown
var mobile_dropdown = document.querySelector(".has-sticky-subscription-loop .sticky-variants-dropdown")
if(mobile_dropdown != null){
  mobile_dropdown.addEventListener("click", function () {       
    var variant_wrapper = this.nextElementSibling;
    this.classList.toggle('active');
    variant_wrapper.classList.toggle('open');
  });
}

if(document.querySelector('#stickBar-loop-subscriptions') && document.querySelector('.loop-subscription-container')){
  const loopContainer = document.querySelector('.loop-subscription-container');
  var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
          document.querySelector('#stickBar-loop-subscriptions').innerHTML = '';
          document.querySelector('#stickBar-loop-subscriptions').appendChild(loopContainer.cloneNode(true));
          document.querySelector('.stickyBar__container .routine-price .regular-price').innerHTML = document.querySelector('.clearRoutine__container .routine-price .price').innerHTML;
      });
  });
  var config = { attributes: true, childList: true, characterData: true, subtree: true }
  observer.observe(loopContainer, config);
  
  document.querySelector('#stickBar-loop-subscriptions').appendChild(loopContainer.cloneNode(true));

  document.querySelector('#stickBar-loop-subscriptions').addEventListener('click', (event) => {
    if(event.target.closest('.selling-plans-list')){
        const stickyVariantId = document.querySelector('#stickyVariantID').value
        const inputId = event.target.id;
        document.querySelector('#loop-product-variant-'+stickyVariantId+' #'+inputId).click();
    }
    else{
        const checkbox = event.target.closest('.checkbox-wrapper');
        if(checkbox){
        const inputId = checkbox.querySelector('input').id;
        document.querySelector('#'+inputId).click();
        }
    }
  });
}
